import type { CSSProperties, ReactNode } from "react";
import styles from "./SocialPost.module.css";

export type SocialPostCardProps = {
  authorName: string;
  author?: ReactNode;
  avatar?: ReactNode;
  metadata?: ReactNode;
  actions?: ReactNode;
  title?: ReactNode;
  teaser?: ReactNode;
  cover?: ReactNode;
  body?: ReactNode;
  media?: ReactNode;
  locked?: ReactNode;
  footer?: ReactNode;
  id?: string;
  className?: string;
};

export function SocialAvatar({ name, size = 42, children }: { name: string; size?: number; children?: ReactNode }) {
  return <span className={styles.avatar} style={{ "--social-avatar-size": `${size}px` } as CSSProperties} aria-hidden="true">{children ?? Array.from(name.trim())[0]?.toLocaleUpperCase()}</span>;
}

/** Shared layout for published posts, discussion cards, and inline editors. */
export function SocialPostCard({ authorName, author, avatar, metadata, actions, title, teaser, cover, body, media, locked, footer, id, className }: SocialPostCardProps) {
  return <article className={[styles.card, className].filter(Boolean).join(" ")} id={id}>
    <header className={styles.header}>
      {avatar ?? <SocialAvatar name={authorName} />}
      <div className={styles.identity}>
        <div className={styles.author}>{author ?? authorName}</div>
        {metadata ? <div className={styles.metadata}>{metadata}</div> : null}
      </div>
      {actions ? <div className={styles.headerActions}>{actions}</div> : null}
    </header>
    {title || teaser ? <div className={styles.introduction}>
      {title ? <div className={styles.title}>{typeof title === "string" ? <h3>{title}</h3> : title}</div> : null}
      {teaser ? <div className={styles.teaser}>{typeof teaser === "string" ? <p>{teaser}</p> : teaser}</div> : null}
    </div> : null}
    {cover ? <div className={styles.cover}>{cover}</div> : null}
    {locked ? <div className={styles.locked}>{locked}</div> : body || media ? <div className={styles.content}>
      {body ? <div className={styles.body}>{typeof body === "string" ? <p>{body}</p> : body}</div> : null}
      {media ? <div className={styles.media}>{media}</div> : null}
    </div> : null}
    {footer ? <div className={styles.footer}>{footer}</div> : null}
  </article>;
}
